export class CostReviewOperationRequestBase{
    estimateId?: string;
    originalReviewerId?: string;
}

export class CostReviewApproveRequest extends CostReviewOperationRequestBase{
}

export class CostReviewDenyRequest extends CostReviewOperationRequestBase{
    denyComments?: string;
}

export class CostReviewUpdateTRRStatusRequest extends CostReviewOperationRequestBase{
    trrStatus?: string;
}
